import { useRef } from "react";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { digits, maskCep } from "@/lib/api";

const upperUf = (v) => v.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);

export function AddressForm({ value: a, onChange, id }) {
  const cur = useRef(a);
  cur.current = a;
  const set = (patch) => onChange({ ...cur.current, ...patch });
  const lookup = async () => {
    const cep = digits(a.cep);
    if (cep.length !== 8) return;
    try {
      const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`).then((x) => x.json());
      const b = cur.current;
      if (!r.erro) set({ street: r.logradouro || b.street, district: r.bairro || b.district, city: r.localidade || b.city, state: r.uf || b.state });
    } catch {
      /* preenchimento manual */
    }
  };
  const inp = (k, label, cls, extra = {}) => (
    <Field label={label} className={cls}>
      <Input value={a[k]} onChange={(e) => set({ [k]: extra.mask ? extra.mask(e.target.value) : e.target.value })} onBlur={extra.onBlur}
        inputMode={extra.inputMode} placeholder={extra.placeholder} data-testid={`${id}-${k}-input`} />
    </Field>
  );
  return (
    <div className="grid grid-cols-6 gap-3" data-testid={`${id}-form`}>
      {inp("cep", "CEP", "col-span-3 sm:col-span-2", { mask: maskCep, onBlur: lookup, inputMode: "numeric", placeholder: "00000-000" })}
      {inp("street", "Rua *", "col-span-6 sm:col-span-4")}
      {inp("number", "Número", "col-span-2")}
      {inp("complement", "Complemento", "col-span-4", { placeholder: "Apto, bloco, referência" })}
      {inp("district", "Bairro", "col-span-6 sm:col-span-3")}
      {inp("city", "Cidade *", "col-span-4 sm:col-span-2")}
      {inp("state", "UF *", "col-span-2 sm:col-span-1", { mask: upperUf })}
    </div>
  );
}
